var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#00CBAF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55027 9.96581C4.59106 10.0114 4.65684 10.0114 4.69894 9.96581L6.51853 7.94258L8.19735 9.83054C8.23813 9.87612 8.30523 9.87612 8.34602 9.83054L10.1577 7.80657L11.9694 5.78259C12.0102 5.73701 12.0102 5.66202 11.9694 5.61644L11.4484 5.03417C11.4286 5.01228 11.4019 5 11.3741 5C11.3462 5 11.3195 5.01228 11.2997 5.03417L8.27366 8.41457L6.59748 6.52954C6.57769 6.50765 6.55098 6.49537 6.52314 6.49537C6.4953 6.49537 6.46859 6.50765 6.4488 6.52954L4.03058 9.21592C4.01099 9.23803 4 9.26789 4 9.299C4 9.33011 4.01099 9.35997 4.03058 9.38207L4.55027 9.96581Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartIcon);
export default __webpack_public_path__ + "static/media/line-chart-icon.140141dfd2458fb783b134b7a68dd667.svg";
export { ForwardRef as ReactComponent };